
import React from 'react'
import { useTranslation } from 'react-i18next'
import { MyDrawer } from '../../MyDrawer'

export interface PDTContentDrawerProps {
  onClose: () => void
}

export const PDTContentDrawer: React.FC<PDTContentDrawerProps> = ({ onClose }) => {
  const { t } = useTranslation('mcfStep1Page')

  return (
    <MyDrawer
      containerId='medicare-my-pdt-drawer'
      onClose={onClose}
      heading={t('PDT.partAB')}
      eventNamespace="mcf"
      openEventKey="mcf_pdtdrawer_opendrawer"
      closeEventKey="mcf_pdtdrawer_closedrawer"
    >
      <p>{t('PDT.text')}</p>
      <div className='my-u-image ds-u-md-padding-y--1 ds-u-xl-padding-y--2 ds-u-justify-content--center'>
        <img alt='Medicare card example' src={`${process.env.PUBLIC_URL}/img/medicare-card-highlight-coverage.png`} />
      </div>
    </MyDrawer>
  )
}
